export const CONTAINER_MAX_WIDTH = "lg";
